module.exports = __webpack_public_path__ + "static/media/gorne-wy-2.63b10cf7.svg";